import React, { Component } from 'react';
import COLORS from '../../../../common/colors';
import FacebookIcon from '../../elements/icons/facebookIcon';
import TwitterIcon from '../../elements/icons/twitterIcon';
import InstagramIcon from '../../elements/icons/instagramIcon';
import LinkedinIcon from '../../elements/icons/linkedinIcon';
import { ToggleButton } from '../../elements/buttons';
import NoSSR from '../../elements/noSSR';
// import './footer.scss';

const _getLocalStore = name => {
	try {
		return JSON.parse(localStorage.getItem(name));
	} catch (err) {
		return null;
	}
};

// const homelinksData = [
// 	{ heading: 'About Us', src: '/aboutus', rel: null, target: null },
// 	{
// 		heading: 'Give India Fundraisers',
// 		src: 'https://fundraisers.giveindia.org',
// 		rel: 'noopener noreferrer',
// 		target: '_blank'
// 	},
// 	{
// 		heading: 'Workplace Giving',
// 		src: 'https://workplace.giveindia.org/',
// 		rel: 'noopener noreferrer',
// 		target: '_blank'
// 	},
// 	{
// 		heading: 'Partner NGOs',
// 		src: '/certified-indian-ngos',
// 		rel: null,
// 		target: null
// 	},
// 	{ heading: 'NGOs in India', src: '/all-ngos/', rel: null, target: null },
// 	{
// 		heading: 'Previous platform',
// 		src: 'https://gi.giveindia.org/',
// 		rel: 'noopener noreferrer',
// 		target: '_blank'
// 	},
// 	{ heading: 'Give Assured', src: '/giveassured', rel: null, target: null },
// 	{ heading: 'Blogs', src: '/blog', rel: null, target: null },
// 	{ heading: 'Careers', src: '/careers', rel: null, target: '_blank' },
// 	{
// 		heading: 'Help',
// 		src: 'https://support.giveindia.org/support/home',
// 		rel: null,
// 		target: '_blank'
// 	},
// 	{ heading: 'Contact Us', src: '/contactus', rel: null, target: '_blank' }
// ];

const homelinksData = [
	{
		type: 'getToKnow',
		name: 'Get to know us',
		list: [
			{ heading: 'About Us', src: '/aboutus', rel: null, target: null },
			{ heading: 'Careers', src: '/careers', rel: null, target: '_blank' },
			{ heading: 'Blog', src: '/blog/', rel: null, target: '_blank' },
			{
				heading: 'Legal & Financials',
				src: '/aboutus#legal',
				rel: null,
				target: '_blank'
			}
		]
	},
	{
		type: 'connectWithUs',
		name: 'Connect with us',
		list: [
			{ heading: 'Contact Us', src: '/contactus', rel: null, target: '_blank' },
			{
				heading: 'Help Center',
				src: 'https://support.giveindia.org/support/home',
				rel: null,
				target: '_blank'
			},
			{
				heading: 'Newsletter',
				src: '/newsletters',
				rel: null,
				target: '_blank'
			}
		]
	},
	{
		type: 'getInvolved',
		name: 'Get Involved',
		list: [
			{
				heading: 'Corporate Partnerships',
				src: 'https://workplace.giveindia.org/',
				rel: null,
				target: '_blank'
			},
			{
				heading: 'Brand & Retail Partnerships',
				src:
					'https://partnerships.giveindia.org/',
				rel: null,
				target: '_blank'
			},
			{
				heading: 'Fundraise',
				src: 'https://fundraisers.giveindia.org/start-a-campaign',
				rel: 'noopener noreferrer',
				target: '_blank'
			},
			{
				heading: 'Institutional Giving',
				src: 'https://institutionalgiving.giveindia.org/',
				rel: 'noopener noreferrer',
				target: '_blank'
			}
		]
	},

	{
		type: 'donate',
		name: 'Donate',
		list: [
			{
				heading: 'Monthly Giving',
				src: '/monthly',
				rel: null,
				target: '_blank'
			},
			{
				heading: 'Fundraisers',
				src: 'https://fundraisers.giveindia.org/',
				rel: 'noopener noreferrer',
				target: '_blank'
			},
			{
				heading: 'COVID Missions',
				src: 'https://covid.giveindia.org',
				rel: 'noopener noreferrer',
				target: '_blank'
			}
		]
	}

	// {
	// 	heading: 'Workplace Giving',
	// 	src: 'https://workplace.giveindia.org/',
	// 	rel: 'noopener noreferrer',
	// 	target: '_blank'
	// },
	// {
	// 	heading: 'Partner NGOs',
	// 	src: '/certified-indian-ngos',
	// 	rel: null,
	// 	target: null
	// },
	// { heading: 'NGOs in India', src: '/all-ngos/', rel: null, target: null },
	// {
	// 	heading: 'Previous platform',
	// 	src: 'https://gi.giveindia.org/',
	// 	rel: 'noopener noreferrer',
	// 	target: '_blank'
	// },
	// { heading: 'Give Assured', src: '/giveassured', rel: null, target: null },
];

export default class Footer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			missionsData: [],
			causesData: [],
			currency: 'INR',
			toggle: false
		};
	}

	componentDidMount() {
		const { session } = this.props;
		if (this.props.tenantConfig?.header?.menuLinks) {
			let missionsData = this.props.tenantConfig.header.menuLinks.filter(
				item => item.heading === 'Missions'
			);
			if (missionsData.length > 0) {
				this.setState({ missionsData: missionsData[0].missions });
			}
			let causesData = this.props.tenantConfig.header.menuLinks.filter(
				item =>
					item.heading !== 'Missions' &&
					item.heading !== 'Support Covid Missions'
			);
			if (causesData.length > 0) {
				this.setState({ causesData: causesData });
			}
		}
		let currentCurrency = 'INR';
		const localStoreCurrency = _getLocalStore('currentCurrency');
		if (localStoreCurrency) {
			currentCurrency = localStoreCurrency;
		} else if (session && session.currentCurrency) {
			currentCurrency = session.currentCurrency;
		} else if (session && session.country) {
			currentCurrency = session.country;
		}
		if (currentCurrency === 'INR' || currentCurrency === 'IN') {
			this.setState({
				currency: 'INR',
				toggle: false
			});
		} else {
			this.setState({
				currency: 'USD',
				toggle: true
			});
		}
	}

	toggleButton = () => {
		const currency = this.state.toggle ? 'INR' : 'USD';
		this.setState({
			toggle: !this.state.toggle
		});
		this.changeCurrentCurrency(currency);
	};

	changeCurrentCurrency = e => {
		localStorage.setItem('currentCurrency', JSON.stringify(e));
		localStorage.setItem('isCurrencyChanged', true);
		// TODO Add case to handle US and USA here.
		this.setState({
			currency: e
		});
		if (window.eventDispatcher) {
			window.eventDispatcher.dispatchEventSync(
				'currencyToggle',
				{},
				{ amplitude: true }
			);
		}
		window.location.reload();
	};

	render() {
		const { missionsData, causesData } = this.state;
		return (
			<div className="homescreen-footer" id="footer">
				<div className="hs-footer-box">
					{/* <div className="hs-footer-mission-cause">
						{missionsData.length > 0 && (
							<div className="hs-footer-mission">
								<div className="hs-footer-heading">Mission</div>
								{missionsData.map((item, idx) => {
									return (
										<p className="hs-footer-item" key={idx}>
											<a href={item.src}>{item.heading}</a>
										</p>
									);
								})}
							</div>
						)}
						{causesData.length > 0 && (
							<div className="hs-footer-cause">
								<div className="hs-footer-heading">Causes</div>
								{causesData.map((item, idx) => {
									return (
										<p className="hs-footer-item" key={idx}>
											<a href={item.src}>{item.heading}</a>
										</p>
									);
								})}
							</div>
						)}
					</div> */}
					<div className="hs-footer-homelinks">
						{homelinksData.map((item, idx) => {
							return (
								<div className="hs-footer-hl-list" key={idx}>
									<div className="hs-footer-hl-list-heading">{item.name}</div>
									{item.list.map((subItem, subIdx) => {
										return (
											<div className="hs-footer-hl-list-item" key={subIdx}>
												<a
													href={subItem.src}
													target={subItem.target}
													rel={subItem.rel}
												>
													{subItem.heading}
												</a>
											</div>
										);
									})}
								</div>
							);
						})}
					</div>
					<div className="hs-footer-social-currency">
						<NoSSR>
							<div className="hs-footer-currency-input">
								<ToggleButton
									toggleButton={this.toggleButton}
									toggle={this.state.toggle}
									classNames={
										this.state.toggle
											? 'btn btn-toggle active no-hover'
											: 'btn btn-toggle no-hover'
									}
								/>
							</div>
						</NoSSR>
						<div className="hs-footer-social">
							{/* <div className="hs-footer-heading">Social Presence</div> */}
							<div className="hs-footer-social-icons">
								<span>
									<a
										rel="noopener noreferrer"
										href="https://www.facebook.com/GiveIndia/"
										target="_blank"
									>
										<FacebookIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
								<span>
									<a
										rel="noopener noreferrer"
										href="https://twitter.com/giveindia/"
										target="_blank"
									>
										<TwitterIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
								<span>
									<a
										rel="noopener noreferrer"
										href="https://www.instagram.com/give_india/"
										target="_blank"
									>
										<InstagramIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
								<span>
									<a
										rel="noopener noreferrer"
										href="https://www.linkedin.com/company/giveindia/"
										target="_blank"
									>
										<LinkedinIcon
											style={{ display: 'flex', alignItems: 'center' }}
											size={20}
											color={`${COLORS.giveMidGrey}`}
										/>
									</a>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="hs-footer-bottom-bar">
					<div className="hs-footer-bb-box">
						<div className="hs-footer-bottom-left">
							<div className="hs-footer-bottom-left-logo">© GiveIndia</div>
							<div className="hs-footer-bottom-left-text">
								Donations through this platform are tax exempted under 80G &amp;
								501(c)(3)
							</div>
						</div>
						<div className="hs-footer-bottom-right">
							<span>
								<a className="no-hover-a" href="/terms">
									Terms
								</a>
							</span>
							<span>
								<a className="no-hover-a" href="/privacy">
									Privacy Policy
								</a>
							</span>
							<span>
								<a href="/sitemap">Site Map</a>
							</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
